module.exports = __webpack_public_path__ + "static/media/features-meu.b432997c.jpg";